jQuery(function ($) {

  $(document).ready(function () {

  });



  $(window).on('load', function () {
    conformHeight();
  });



  $(window).on('resize', function () {
    conformHeight();
  });





  /*--------------------------------------------------
  Conformity
  For equal height elements based on row rather than set.
  https://github.com/codekipple/conformity
  ---------------------------------------------------*/
  function conformHeight() {
    // Used by various "Product" image grids
    $('.single-article').conformity();

  }// conformHeight 
});
document.addEventListener("DOMContentLoaded", function() {
  if ($(window).width() < 740) {
    $('ul#blog-articles').insertBefore('#blog-sidebar');
  }
});
